import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import * as types from '../constants/actionTypes'
import { GENERAL_ADMISSION } from './reducer'

const generalAdmissionSelector = (state: RootState) => prop(GENERAL_ADMISSION, state)

export const generalApplicationSelector = createSelector(generalAdmissionSelector, prop(types.GENERAL_APPLICATION))

export const generalApplicationListSelector = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_LIST)
)

export const generalApplicationTypesSelector = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_TYPES)
)

export const generalApplicationStatusSelector = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_STATUS)
)

export const generalApplicationAllSelector = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_ALL)
)
export const generalApplicationFieldBatchSelector = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_FIELD_BATCH)
)

// category
// export const generalApplicationCategoryListSelector = createSelector(
//   generalAdmissionSelector,
//   prop(types.GENERAL_APPLICATION_CATEGORY_LIST)
// )
// export const generalApplicationCategoryAllSelector = createSelector(
//   generalAdmissionSelector,
//   prop(types.GENERAL_APPLICATION_CATEGORY_ALL)
// )

// request
export const generalApplicationRequestAll = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_REQUEST_ALL)
)
export const generalApplicationRequestEdit = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_REQUEST_EDIT)
)

export const generalApplicationRequestUpdate = createSelector(
  generalAdmissionSelector,
  prop(types.GENERAL_APPLICATION_REQUEST_UPDATE)
)
